<div class="modal-header">
  <h5 class="modal-title">Ask our AI about {{ campaignName }}'s campaign</h5>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="content-wrapper">
    <div
      class="icon-circle"
      (click)="continue()"
      role="button"
      tabindex="0"
      (keydown.enter)="continue()"
      (keydown.space)="continue()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="white"
        width="32"
        height="32"
        aria-labelledby="continueArrowTitle"
      >
        <title id="continueArrowTitle">Continue arrow</title>
        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
      </svg>
    </div>

    <h3 class="heading">REDIRECTING YOU TO OUR AI CHATBOT</h3>

    <p class="description">
      You'll be taken to a new tab where you can continue your conversation with our AI assistant.
    </p>
  </div>
</div>
